/* TH | Tabbed Content Slider — tab switching + slideshow with cross-tab navigation */
(function () {
  function initSection(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.hw-tabbed-tab'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.hw-tabbed-panel'));
    if (!tabs.length || !panels.length) return;

    function activateTab(index, slideIndex) {
      if (index < 0) index = tabs.length - 1;
      if (index >= tabs.length) index = 0;

      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });

      var panel = panels[index];
      var count = parseInt(panel.getAttribute('data-image-count') || '0', 10);
      if (count <= 0) return;

      if (typeof slideIndex !== 'number' || isNaN(slideIndex)) slideIndex = 0;
      if (slideIndex < 0) slideIndex = count - 1;
      if (slideIndex >= count) slideIndex = 0;

      setSlide(panel, slideIndex);
    }

    function setSlide(panel, slideIndex) {
      var slides = panel.querySelectorAll('.hw-tabbed-slide');
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === slideIndex);
      });
      var current = panel.querySelector('.hw-tabbed-counter__current');
      if (current) current.textContent = String(slideIndex + 1);
    }

    function getActiveIndex() {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function getCurrentSlideIndex(panel) {
      var slides = panel.querySelectorAll('.hw-tabbed-slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    // Tab click → switch tab, reset to first slide
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.getAttribute('data-tab-index') || '0', 10);
        activateTab(idx, 0);
      });
    });

    // Arrow click → navigate within current tab; spill over to neighbor tab at boundaries
    panels.forEach(function (panel, panelIdx) {
      var prev = panel.querySelector('.hw-tabbed-arrow--prev');
      var next = panel.querySelector('.hw-tabbed-arrow--next');
      var count = parseInt(panel.getAttribute('data-image-count') || '0', 10);

      if (next) {
        next.addEventListener('click', function () {
          var current = getCurrentSlideIndex(panel);
          if (current + 1 < count) {
            setSlide(panel, current + 1);
          } else {
            // Last slide → jump to next tab's first slide
            var nextTabIdx = (panelIdx + 1) % tabs.length;
            activateTab(nextTabIdx, 0);
          }
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          var current = getCurrentSlideIndex(panel);
          if (current > 0) {
            setSlide(panel, current - 1);
          } else {
            // First slide → jump to previous tab's last slide
            var prevTabIdx = (panelIdx - 1 + tabs.length) % tabs.length;
            var prevPanel = panels[prevTabIdx];
            var prevCount = parseInt(prevPanel.getAttribute('data-image-count') || '0', 10);
            activateTab(prevTabIdx, Math.max(0, prevCount - 1));
          }
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.hw-tabbed-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.hw-tabbed-section');
    if (sec) initSection(sec);
  });
})();
